import { queryOptions } from '@tanstack/react-query';

import { fetchMatchFormGuide, fetchTeamFormGuide } from '@apis/cards';

export const getMatchFormGuideQuery = (matchId: string, numberOfMatches?: number) =>
  queryOptions({
    queryKey: ['form-guide', matchId, numberOfMatches],
    queryFn: ({ signal }) => fetchMatchFormGuide(matchId, numberOfMatches, signal),
    select: (data) => data?.data,
  });

export const getTeamFormGuideQuery = (teamIds: string | string[], numberOfMatches?: number) =>
  queryOptions({
    queryKey: ['form-guide', teamIds, numberOfMatches],
    queryFn: ({ signal }) => fetchTeamFormGuide(teamIds, numberOfMatches, signal),
    select: (data) => data?.data,
  });
